// roleStore.js
let inMemoryRoles = [];

export function setRoles(rolesArray) {
    inMemoryRoles = rolesArray;
}

export function getRoles() {
    return inMemoryRoles;
}

const hasRole = (roles, validRoles) => {
    return roles.some(role => validRoles.some(validRole => role.indexOf(validRole) > -1));
}

export const isSupportAgent2 = () => {
    const roles = getRoles();
    return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD', 'SUPPORT_AGENT_3', 'SUPPORT_AGENT_2']);
}

export const isSupportAgent3 = () => {
    const roles = getRoles();
    return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD', 'SUPPORT_AGENT_3']);
}

export const isSupportLead = () => {
    const roles = getRoles();
    return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD']);
}

export const isSupportLead2 = () => {
    const roles = getRoles();
    return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD','SUPPORT_LEAD_2']);
}

export const isSupportManager = () => {
    const roles = getRoles();
    return hasRole(roles, ['SUPPORT_MANAGER']);
}

export const isSupportAgent = () => {
    const roles = getRoles();
    return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD', 'SUPPORT_AGENT_3', 'SUPPORT_AGENT_2', 'SUPPORT_AGENT_1']);
}

export const isFurnishingAdmin = () => {
    const roles = getRoles();
    return hasRole(roles, ['FURNISHING_ADMIN']);
}

export const isSupportEngineer = () => {
    const roles = getRoles();
    return hasRole(roles, ['SUPPORT_ENGINEER']);
}

// "hasRole" or "isSupportManager" just read from inMemoryRoles now:
export function isDev() {
    const roles = getRoles();
    return hasRole(roles, ['DEV']);
}
